import styled, { css } from "styled-components"

// Tabs List
export const StyledTabsList = styled.div`
  display: inline-flex;
  height: 2.5rem;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  background-color: var(--muted, #f3f4f6);
  padding: 0.25rem;
  color: var(--muted-foreground, #6b7280);
`


export const StyledTabsTrigger = styled.button<{ active: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border-radius: 0.25rem;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s;
  background: transparent;
  border: none;

  ${({ active }) =>
    active &&
    css`
      background-color: var(--background, white);
      color: var(--foreground, black);
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    `}

  &:focus-visible {
    outline: 2px solid var(--ring, #3b82f6);
    outline-offset: 2px;
  }

  &:disabled {
    pointer-events: none;
    opacity: 0.5;
  }
`

export const StyledTabsContent = styled.div`
  margin-top: 0.5rem;

  &:focus-visible {
    outline: 2px solid var(--ring, #3b82f6);
    outline-offset: 2px;
  }
`